export default __webpack_public_path__ + "static/media/PURP_PNA.7dcb6980.mp4";